import { ActionError } from '@core-models/errors/action-error';
import { ProfileActionErrors } from '@profile/enums/profile-action-errors';
import { ChildAccount } from '../../../profile-base/interfaces/child-account/child-account';

export class ProfileBaseState {
    additionalProfiles: ChildAccount[] = [];
    error: ActionError<ProfileActionErrors>;
}